import React from "react";
import { Tabs, Tab, Divider, Avatar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Person } from "@mui/icons-material";
import { useAuth } from "hooks/useAuth";

export const NavApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const { user } = useAuth();
  const values = ["/", "/dashboard", "/profil"];

  const handleChange = (event: any, newValue: any) => {
    navigate(newValue);
  };

  return (
    <>
      {/* <Tabs
        value={values.includes(currentPath) ? currentPath : false}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Accueil" value="/" />
        <Tab label="Tableau de bord" value="/dashboard" />
        {Boolean(user) ? (
          <Tab
            value="/profil"
            sx={styles.tabLogin}
            icon={<Avatar>{user?.displayName?.[0]}</Avatar>}
          />
        ) : (
          <Tab value="/auth" sx={styles.tabLogin} icon={<Person />} />
        )}
      </Tabs>

      <Divider /> */}
    </>
  );
};

const styles = {
  tabLogin: {
    position: "absolute",
    right: 0,
  },
};
